export interface IResponse {
  results: any;
  response: 'SUCCESSFUL' | 'FAILED';
  message: string;
  next?: string | null;
  count?: number | null;
  previous?: string | null;
}

export interface IErrorResponse {
  response: 'SUCCESSFUL' | 'FAILED';
  message: string;
}

export enum ResponseType {
    SUCCESSFUL = "SUCCESSFUL",
    FAILED = "FAILED"
}